export default "__VITE_ASSET__Cf1OzVf8__"